var uniqueId = function () {
  var map = {};
  return function (prefix) {
    prefix = prefix || 'g';

    if (!map[prefix]) {
      map[prefix] = 1;
    } else {
      map[prefix] += 1;
    }

    return prefix + map[prefix];
  };
}();

module.exports = uniqueId;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/util/lib/unique-id.js
// module id = 62
// module chunks = 0 1 2